import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { NavLink } from "../core/layouts/types";
import { ArrowRightOutlined } from "./icons/arrow-right-outlined";
import { hasPermission } from "../core/utils";
import { getUserState } from "../redux/features/auth-slice";

interface NavLinkItemProps {
  item: NavLink;
  toggleNav: (value: boolean) => void;
}

export default function NavLinkItem(props: NavLinkItemProps) {
  const { item, toggleNav } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const user = useSelector(getUserState).data;

  const [open, setOpen] = useState<boolean>(false);

  const handleClick = (path?: string) => {
    if (path) {
      navigate(path);
      toggleNav(false);
    } else {
      setOpen(!open);
    }
  };

  // function getFirstPartOfPath(path: string) {
  //   const secondSlashIndex = path.indexOf("/", 1);
  //   if (secondSlashIndex === -1) {
  //     return path;
  //   }
  //   const firstPartOfPath = path.substring(0, secondSlashIndex);
  //   return firstPartOfPath;
  // }

  // function getLastPartOfPath(path: string) {
  //   const lastSlashIndex = path.lastIndexOf("/");
  //   if (lastSlashIndex === -1) {
  //     return path;
  //   }
  //   const lastPartOfPath = path.substring(lastSlashIndex + 1);
  //   return lastPartOfPath;
  // }

  useEffect(() => {
    if (item.child?.some((e) => location.pathname.includes(e.id))) {
      setOpen(true);
    }
  }, [currentPath, item]);

  return (
    <li className="mb-1">
      <div
        className={`flex items-center justify-start ${
          item.child ? "mb-1" : ""
        } ${item.disabled ? "text-action-disabled" : ""}`}
        onClick={() => {
          if (!item.disabled) {
            handleClick(item.path);
          }
        }}
      >
        <div
          className={`w-full flex items-center justify-between text-xs hover:text-text-primary p-3 hover:bg-gray-200 rounded-lg cursor-pointer mx-4 ${
            item.path === currentPath
              ? "bg-gray-200 text-text-primary"
              : "text-text-title"
          }`}
        >
          {item.title}
          {item.child && (
            <ArrowRightOutlined
              style={{
                height: 13,
                width: 13,
                transform: open ? "rotate(90deg)" : "rotate(0deg)",
                transitionDuration: "200ms",
                transitionTimingFunction: "ease-in-out",
                transitionProperty: "transform",
              }}
            />
          )}
        </div>
      </div>
      {open && (
        <div
          className={`ml-8 mr-4 border-l-2 border-divider pl-1 ${
            open ? "slide-down" : "slide-up overflow-hidden"
          }`}
        >
          {item.child &&
            item.child
              .filter((nav: NavLink) =>
                hasPermission(user, nav.category, nav.role)
              )
              .map((e: NavLink) => {
                return (
                  <div
                    key={e.id}
                    className="flex items-center justify-start mb-1"
                    onClick={() => {
                      toggleNav(false);
                      handleClick(e.path);
                    }}
                  >
                    <div
                      className={`w-full flex items-center justify-between text-xs p-3 hover:text-text-primary hover:bg-gray-200 cursor-pointer rounded-lg ${
                        decodeURIComponent(location.pathname).includes(e.id)
                          ? "bg-gray-200 text-text-primary font-medium"
                          : "text-text-title"
                      }`}
                    >
                      {e.title}
                    </div>
                  </div>
                );
              })}
        </div>
      )}
    </li>
  );
}
